import { render, staticRenderFns } from "./ProductAddEditModal.vue?vue&type=template&id=f180c98a&"
import script from "./ProductAddEditModal.vue?vue&type=script&lang=js&"
export * from "./ProductAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports